import cfg from "./config";

export const CSRF_TOKEN_COOKIE_NAME =
  process.env.VUE_APP_CSRF_TOKEN_COOKIE_NAME;
export const INVITE_COOKIE_NAME = process.env.VUE_APP_INVITE_COOKIE_NAME;

export const config = cfg;
